import React from 'react';
import Box from '@material-ui/core/Box';
import Divider from '@material-ui/core/Divider';
import SwipeableDrawer from '@material-ui/core/SwipeableDrawer';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import { makeStyles } from '@material-ui/core';

import authService from 'common/services/authService';
import UserInfo from 'common/components/header/side-bar/UserInfo';
import UserNotAuthenticated from 'common/components/header/side-bar/UserNotAuthenticated';
import MyListItemHref from 'common/components/header/MyListItemHref';
import Logout from 'common/components/header/Logout';

import {
  sideBarAppRoutes,
  sidebarNavActions,
} from 'common/components/header/headerData';
import {
  FRONTEND_DASHBOARD_URL,
  FRONTEND_PROFILE_EDIT_URL,
} from 'common/utils/constants';
import NavbarListItem from 'home/components/NavbarListItem';
import { forIndividuals } from 'home/utils/utils';

const SideBar: React.FC<ISideBarProps> = ({
  drawer,
  toggleDrawer,
  RouteLink,
}) => {
  const classes = useStyles();

  return (
    <SwipeableDrawer
      anchor="right"
      open={drawer}
      onClose={toggleDrawer(false)}
      onOpen={toggleDrawer(true)}
    >
      <List className={classes.list_root}>
        <ListItem divider className={classes.listitem_auth}>
          {authService.isAuthenticated ? (
            <UserInfo />
          ) : (
            <UserNotAuthenticated />
          )}
        </ListItem>
        <Box className={classes.box_root}>
          <NavbarListItem label="Learn AI" data={forIndividuals} />
          {sideBarAppRoutes.map(({ id, ...props }) => (
            <MyListItemHref
              key={id}
              RouteLink={RouteLink}
              toggleDrawer={toggleDrawer}
              {...props}
            />
          ))}
          <Divider
            variant="fullWidth"
            className={classes.listitem_divider}
          />
          {authService.isAuthenticated ? (
            <>
              <MyListItemHref
                route={FRONTEND_PROFILE_EDIT_URL}
                label="Profile"
                RouteLink={RouteLink}
                toggleDrawer={toggleDrawer}
              />
              <MyListItemHref
                route={FRONTEND_DASHBOARD_URL}
                label="Dashboard"
                RouteLink={RouteLink}
                toggleDrawer={toggleDrawer}
                isReactLink
              />
              <Logout />
            </>
          ) : (
            <>
              {sidebarNavActions.map(({ id, ...props }) => (
                <MyListItemHref
                  key={id}
                  RouteLink={RouteLink}
                  toggleDrawer={toggleDrawer}
                  {...props}
                />
              ))}
            </>
          )}
        </Box>
      </List>
    </SwipeableDrawer>
  );
};

export default SideBar;

const useStyles = makeStyles((theme) => ({
  list_root: {
    minWidth: 270,
    [theme.breakpoints.down('sm')]: {
      width: 270,
    },
  },
  box_root: {
    '& .MuiListItem-root': {
      cursor: 'pointer',
      paddingTop: 4,
      paddingBottom: 4,
    },
    '& .MuiListItem-root:hover': {
      width: '100%',
      backgroundColor: 'rgba(68, 146, 76, 0.04)',
    },
  },
  listitem_auth: {
    marginBottom: 16,
  },
  listitem_divider: {
    marginBottom: 16,
    marginTop: 16,
  },
}));
